<template>
  <span @click="$emit('click')">
    <template v-if="isEnableLanguage">
      <a-popover placement="topLeft">
        <template slot="content">
          <div style="width: 200px">
            <a-row v-for="(item, index) in popLists" :key="index">
              <a-col :span="8" style="text-align: right; font-weight: bold">{{ item.langType }}：</a-col>
              <a-col :span="16">{{ item.langText }}</a-col>
            </a-row>
          </div>
        </template>
        <slot>
          <span>{{ langText }}</span>
        </slot>
      </a-popover>
    </template>
    <span v-else>
      <slot>
        <span>{{ langText }}</span>
      </slot>
    </span>
  </span>

</template>
<script>
export default {
  name: 'mtcLangPopover',
  props: {
    // 传入是否为多语言
    text: {
      type: String,
      require: true,
      default: ''
    },
    defaultTitle: {
      type: String,
      default: ''
    }
  },
  computed: {
    langText() {
      //先只改在线表单 目前先做兼容
      if(!this.defaultTitle){
        return this.$t(this.text) || this.text
      }
      return this.$getLanguageEnable() ? this.$t(this.text) || this.text : this.defaultTitle
    },
    isEnableLanguage(){
      return this.$getLanguageEnable() && this.popLists.length ;
    },
    popLists() {
      let secondLanguage = JSON.parse(this.$ls.get('secondLanguage')) || []
      if (!this.text) return {}
      let secondLabel = secondLanguage.map(ele => {
        return {
          langType: ele,
          langText: this.$t(this.text, ele) || this.$t('tip.noData')
        }
      })
      return secondLabel
    }
  }
}
</script>

<style>
</style>